export default {
  enabled: false, // toggled in tuner.js on setup()
  log: function (message, context) {
    if (this.enabled) {
      console.log(`[DEBUG][TUNER] ${message}`, context || ''); // eslint-disable-line no-console
    }
  },
};
